export default __webpack_public_path__ + "b004a0a1c26da1d179e196cd639f3f5e.png";